import React from 'react';

import { Gutter } from '@common/components';
import {
  AuthTemplateCentralizedContainer,
  AuthTemplateLogo,
  ResetPasswordForm,
} from '@identity/components';

export const ActivateAccountPage = () => (
  <AuthTemplateCentralizedContainer>
    <AuthTemplateLogo />
    <Gutter asPadding size="xxl" />
    <ResetPasswordForm
      passwordName="password"
      title="Activate your account"
      submitButtomLabel="Activate Account"
      successMessage="Account successfully activated. Sign in to continue."
    />
  </AuthTemplateCentralizedContainer>
);
